var _toConsumableArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-VendorEngage_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/data/var/lib/jenkins/workspace/TMI-Portal-VendorEngage_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/data/var/lib/jenkins/workspace/TMI-Portal-VendorEngage_warfilebuild_UAT/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/array/from.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayFromJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/from");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js": function node_modulesBabelRuntimeCorejs3CoreJsArrayIsArrayJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/array/is-array");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js": function node_modulesBabelRuntimeCorejs3CoreJsGetIteratorJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/get-iterator");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js": function node_modulesBabelRuntimeCorejs3CoreJsInstanceSliceJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/slice");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js": function node_modulesBabelRuntimeCorejs3CoreJsIsIterableJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/is-iterable");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/symbol.js": function node_modulesBabelRuntimeCorejs3CoreJsSymbolJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/symbol");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js": function node_modulesBabelRuntimeCorejs3HelpersArrayLikeToArrayJs(module, exports) {
    module.exports = function (arr, len) {
      (null == len || len > arr.length) && (len = arr.length);

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeCorejs3HelpersArrayWithHolesJs(module, exports, __webpack_require__) {
    var _Array$isArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/is-array.js");

    module.exports = function (arr) {
      if (_Array$isArray(arr)) return arr;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeCorejs3HelpersIterableToArrayLimitJs(module, exports, __webpack_require__) {
    var _getIterator = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/get-iterator.js"),
        _isIterable = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/is-iterable.js"),
        _Symbol = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/symbol.js");

    module.exports = function (arr, i) {
      if (void 0 !== _Symbol && _isIterable(Object(arr))) {
        var _arr = [],
            _n = !0,
            _d = !1,
            _e = void 0;

        try {
          for (var _s, _i = _getIterator(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !i || _arr.length !== i); _n = !0) {
            ;
          }
        } catch (err) {
          _d = !0, _e = err;
        } finally {
          try {
            _n || null == _i.return || _i.return();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js": function node_modulesBabelRuntimeCorejs3HelpersNonIterableRestJs(module, exports) {
    module.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js": function node_modulesBabelRuntimeCorejs3HelpersSlicedToArrayJs(module, exports, __webpack_require__) {
    var arrayWithHoles = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js"),
        iterableToArrayLimit = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/iterableToArrayLimit.js"),
        unsupportedIterableToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js"),
        nonIterableRest = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/nonIterableRest.js");

    module.exports = function (arr, i) {
      return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/unsupportedIterableToArray.js": function node_modulesBabelRuntimeCorejs3HelpersUnsupportedIterableToArrayJs(module, exports, __webpack_require__) {
    var _Array$from = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/array/from.js"),
        _sliceInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/slice.js"),
        arrayLikeToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/arrayLikeToArray.js");

    module.exports = function (o, minLen) {
      var _context;

      if (o) {
        if ("string" == typeof o) return arrayLikeToArray(o, minLen);

        var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? _Array$from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? arrayLikeToArray(o, minLen) : void 0;
      }
    };
  },
  "./AppFloorPlan.module.scss": function AppFloorPlanModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      appFloorPlan: "jut__AppFloorPlan__appFloorPlan",
      showAside: "jut__AppFloorPlan__showAside",
      showNav: "jut__AppFloorPlan__showNav",
      hideNavAside: "jut__AppFloorPlan__hideNavAside",
      scrollContent: "jut__AppFloorPlan__scrollContent",
      main: "jut__AppFloorPlan__main",
      nav: "jut__AppFloorPlan__nav",
      aside: "jut__AppFloorPlan__aside",
      header: "jut__AppFloorPlan__header",
      footer: "jut__AppFloorPlan__footer"
    };
  },
  "./AppFloorPlanDesign/AppFloorPlanDesign.module.scss": function AppFloorPlanDesignAppFloorPlanDesignModuleScss(module, exports, __webpack_require__) {
    module.exports = {
      rectangle: "jut__AppFloorPlanDesign__rectangle",
      rectangleText: "jut__AppFloorPlanDesign__rectangleText",
      square: "jut__AppFloorPlanDesign__square",
      circle: "jut__AppFloorPlanDesign__circle",
      aside: "jut__AppFloorPlanDesign__aside",
      footer: "jut__AppFloorPlanDesign__footer",
      navLinksHeader: "jut__AppFloorPlanDesign__navLinksHeader",
      navLinks: "jut__AppFloorPlanDesign__navLinks",
      search: "jut__AppFloorPlanDesign__search",
      header: "jut__AppFloorPlanDesign__header",
      subHeader: "jut__AppFloorPlanDesign__subHeader"
    };
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "AppFloorPlan", function () {
      return AppFloorPlan_0;
    }), __webpack_require__.d(__webpack_exports__, "AppFloorPlanDesign", function () {
      return AppFloorPlanDesign_AppFloorPlanDesign;
    });

    __webpack_require__("core-js/modules/web.dom-collections.iterator");

    var extends_ = __webpack_require__("@babel/runtime-corejs3/helpers/extends"),
        extends_default = __webpack_require__.n(extends_),
        external_react_ = __webpack_require__("react"),
        external_react_default = __webpack_require__.n(external_react_),
        external_prop_types_ = __webpack_require__("prop-types"),
        external_prop_types_default = __webpack_require__.n(external_prop_types_),
        external_react_router_dom_ = __webpack_require__("react-router-dom"),
        router_ = __webpack_require__("@jutro/router"),
        uiconfig_ = __webpack_require__("@jutro/uiconfig"),
        prop_types_ = __webpack_require__("@jutro/prop-types"),
        external_classnames_ = __webpack_require__("classnames"),
        external_classnames_default = __webpack_require__.n(external_classnames_),
        theme_ = __webpack_require__("@jutro/theme"),
        AppFloorPlan_module = __webpack_require__("./AppFloorPlan.module.scss"),
        AppFloorPlan_module_default = __webpack_require__.n(AppFloorPlan_module);

    function AppFloorPlanLayout(props) {
      var _external_classnames_;

      var aside = props.aside,
          children = props.children,
          className = props.className,
          darkMode = props.darkMode,
          footer = props.footer,
          header = props.header,
          nav = props.nav,
          scrollContent = props.scrollContent,
          themeStyles = Object(external_react_.useContext)(theme_.ThemeContext).getStyles("AppFloorPlanLayout", AppFloorPlan_module_default.a),
          floorPlanClasses = external_classnames_default()(themeStyles.appFloorPlan, (_external_classnames_ = {}, _defineProperty(_external_classnames_, themeStyles.scrollContent, scrollContent), _defineProperty(_external_classnames_, themeStyles.showAside, !nav), _defineProperty(_external_classnames_, themeStyles.showNav, !aside), _defineProperty(_external_classnames_, themeStyles.hideNavAside, !aside && !nav), _defineProperty(_external_classnames_, "dark", darkMode), _external_classnames_), className);
      return external_react_default.a.createElement("div", {
        className: floorPlanClasses
      }, header && external_react_default.a.createElement("header", {
        className: themeStyles.header
      }, header), nav && external_react_default.a.createElement("nav", {
        className: themeStyles.nav
      }, nav), external_react_default.a.createElement("main", {
        className: themeStyles.main,
        tabIndex: "-1"
      }, children), aside && external_react_default.a.createElement("aside", {
        className: themeStyles.aside
      }, aside), footer && external_react_default.a.createElement("footer", {
        className: themeStyles.footer
      }, footer));
    }

    AppFloorPlanLayout.__docgenInfo = {
      componentName: "AppFloorPlanLayout",
      packageName: "@jutro/floorplan",
      description: "",
      displayName: "AppFloorPlanLayout",
      methods: [],
      actualName: "AppFloorPlanLayout"
    };

    var entries_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/entries"),
        entries_default = __webpack_require__.n(entries_),
        for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        map_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
        map_default = __webpack_require__.n(map_),
        slicedToArray = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/slicedToArray.js"),
        slicedToArray_default = __webpack_require__.n(slicedToArray),
        find_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find"),
        find_default = __webpack_require__.n(find_);

    var matchRoute = function matchRoute(routes, pathname) {
      return find_default()(routes).call(routes, function (route) {
        return Object(external_react_router_dom_.matchPath)(pathname, route);
      });
    };

    var appFloorPlanPropTypes = {
      routes: external_prop_types_default.a.arrayOf(prop_types_.routeShape),
      header: external_prop_types_default.a.shape(_objectSpread({}, router_.ApplicationHeaderPropTypes, {
        helpPopoverItems: external_prop_types_default.a.arrayOf(external_prop_types_default.a.object)
      })),
      aside: external_prop_types_default.a.object,
      footer: external_prop_types_default.a.object,
      darkMode: external_prop_types_default.a.bool,
      scrollContent: external_prop_types_default.a.bool,
      className: external_prop_types_default.a.string,
      componentMap: external_prop_types_default.a.object,
      showNav: external_prop_types_default.a.oneOf(["top", "left", "split"])
    },
        AppFloorPlanWrapper = Object(external_react_router_dom_.withRouter)(AppFloorPlan);

    function AppFloorPlan(props) {
      var className = props.className,
          componentMap = props.componentMap,
          headerProps = props.header,
          asideProps = props.aside,
          routes = props.routes,
          footerProps = props.footer,
          sideNav = props.sideNav,
          scrollContent = props.scrollContent,
          darkMode = props.darkMode,
          showNav = props.showNav,
          _useRoutes = function (_ref) {
        var routes = _ref.routes,
            pathname = _ref.pathname,
            showNav = _ref.showNav;

        var shouldRenderTop = "top" === showNav,
            shouldRenderLeft = "left" === showNav,
            shouldRenderTopAndLeft = "split" === showNav,
            _useState = Object(external_react_.useState)({}),
            _useState2 = slicedToArray_default()(_useState, 2),
            navRoutes = _useState2[0],
            setNavRoutes = _useState2[1];

        var result = {};
        return Object(external_react_.useEffect)(function () {
          if (routes) {
            if (shouldRenderTopAndLeft) {
              var _topRoutes = map_default()(routes).call(routes, function (route) {
                return _objectSpread({}, route, {
                  routes: void 0
                });
              }),
                  activeTopRoute = matchRoute(routes, pathname),
                  sideRootPath = null == activeTopRoute ? void 0 : activeTopRoute.path,
                  _sideRoutes = null == activeTopRoute ? void 0 : activeTopRoute.routes;

              if (_sideRoutes) {
                var _context;

                var activeSideRoute = matchRoute(_sideRoutes, pathname),
                    subPath = null == activeSideRoute ? void 0 : activeSideRoute.path,
                    tempRoutes = _objectSpread({}, _topRoutes, _defineProperty({}, sideRootPath, subPath));

                for_each_default()(_context = entries_default()(tempRoutes)).call(_context, function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      key = _ref3[0],
                      value = _ref3[1];

                  var redirectRoute = find_default()(routes).call(routes, function (_ref4) {
                    var path = _ref4.path,
                        exact = _ref4.exact;
                    return path === key && exact;
                  });
                  redirectRoute && (redirectRoute.redirect = value);
                }), result = {
                  topRoutes: _topRoutes,
                  sideRoutes: _sideRoutes
                };
              } else result = {
                topRoutes: _topRoutes
              };
            }

            shouldRenderTop && (result = {
              topRoutes: routes
            }), shouldRenderLeft && (result = {
              sideRoutes: routes
            }), setNavRoutes(result);
          }
        }, [routes, shouldRenderLeft, shouldRenderTop, pathname]), navRoutes;
      }({
        routes: routes,
        pathname: props.location.pathname,
        showNav: showNav
      }),
          topRoutes = _useRoutes.topRoutes,
          sideRoutes = _useRoutes.sideRoutes,
          header = headerProps && external_react_default.a.createElement(router_.ApplicationHeader, extends_default()({
        navigationRoutes: topRoutes
      }, headerProps, {
        helpPopoverItems: headerProps.helpPopoverItems && Object(uiconfig_.renderContentFromMetadata)(headerProps.helpPopoverItems, void 0, {
          resolveComponentMap: componentMap
        })
      })),
          nav = sideRoutes && external_react_default.a.createElement(router_.SideNavigation, extends_default()({
        routes: sideRoutes
      }, sideNav)),
          aside = asideProps && Object(uiconfig_.renderContentFromMetadata)({
        content: [_objectSpread({
          component: "div"
        }, asideProps)]
      }, void 0, {
        resolveComponentMap: componentMap
      }),
          footer = footerProps && Object(uiconfig_.renderContentFromMetadata)({
        content: [_objectSpread({
          component: "footer",
          componentProps: {
            key: "footer"
          }
        }, footerProps)]
      }, void 0, {
        resolveComponentMap: componentMap
      }),
          floorPlanContent = routes && external_react_default.a.createElement(router_.NavRoutes, {
        resolveComponentMap: componentMap,
        routes: [].concat(_toConsumableArray(topRoutes || []), _toConsumableArray(sideRoutes || []))
      });

      return external_react_default.a.createElement(AppFloorPlanLayout, {
        className: className,
        scrollContent: scrollContent,
        header: header,
        nav: nav,
        aside: aside,
        footer: footer,
        darkMode: darkMode
      }, floorPlanContent);
    }

    AppFloorPlan.propTypes = appFloorPlanPropTypes, AppFloorPlan.defaultProps = {
      scrollContent: !0,
      darkMode: !1,
      showNav: "split"
    };
    var AppFloorPlan_0 = AppFloorPlanWrapper;
    AppFloorPlan.__docgenInfo = {
      componentName: "AppFloorPlan",
      packageName: "@jutro/floorplan",
      description: "Floorplan for the app, giving ability to use footer, header and nav out of the box",
      displayName: "AppFloorPlan",
      methods: [],
      actualName: "AppFloorPlan",
      props: {
        routes: {
          type: {
            name: "arrayOf",
            value: {
              name: "shape",
              value: {
                title: {
                  name: "custom",
                  raw: "intlMessageShape",
                  description: "Route title",
                  required: !1
                },
                path: {
                  name: "string",
                  description: "Route path",
                  required: !1
                },
                showOnNavBar: {
                  name: "bool",
                  description: "When `true` then route will be rendered on nav bar",
                  required: !1
                },
                exact: {
                  name: "bool",
                  description: "When true, will only match if the path matches the location.pathname exactly",
                  required: !1
                },
                navLink: {
                  name: "shape",
                  value: {
                    text: {
                      name: "string",
                      description: "Text for nav link",
                      required: !1
                    },
                    icon: {
                      name: "string",
                      description: "Icon for nav link",
                      required: !1
                    },
                    className: {
                      name: "string",
                      description: "Custom CSS className for nav link",
                      required: !1
                    },
                    activeClassName: {
                      name: "string",
                      description: "Custom CSS className for nav link in active state",
                      required: !1
                    },
                    component: {
                      name: "elementType",
                      description: "React element to render nav item",
                      required: !1
                    }
                  },
                  description: "Nav link props",
                  required: !1
                }
              }
            }
          },
          required: !1,
          description: "Routing metadata object"
        },
        header: {
          type: {
            name: "shape",
            value: {
              helpPopoverItems: {
                name: "arrayOf",
                value: {
                  name: "object"
                },
                required: !1
              }
            }
          },
          required: !1,
          description: "Properties for Application Header component"
        },
        aside: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Content to render in the right side panel"
        },
        footer: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Children components config for Footer"
        },
        darkMode: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Set dark mode",
          defaultValue: {
            value: "false",
            computed: !1
          }
        },
        scrollContent: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Make content scrollable",
          defaultValue: {
            value: "true",
            computed: !1
          }
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: "Additional class names for component."
        },
        componentMap: {
          type: {
            name: "object"
          },
          required: !1,
          description: "Resolve component map"
        },
        showNav: {
          type: {
            name: "enum",
            value: [{
              value: "'top'",
              computed: !1
            }, {
              value: "'left'",
              computed: !1
            }, {
              value: "'split'",
              computed: !1
            }]
          },
          required: !1,
          description: "Define where to put the navigation",
          defaultValue: {
            value: "'split'",
            computed: !1
          }
        }
      }
    };

    var times_ = __webpack_require__("lodash/times"),
        times_default = __webpack_require__.n(times_),
        components_ = __webpack_require__("@jutro/components"),
        layout_ = __webpack_require__("@jutro/layout"),
        locale_ = __webpack_require__("@jutro/locale"),
        AppFloorPlanDesign_module = __webpack_require__("./AppFloorPlanDesign/AppFloorPlanDesign.module.scss"),
        AppFloorPlanDesign_module_default = __webpack_require__.n(AppFloorPlanDesign_module),
        AppFloorPlanDesign_messages = Object(locale_.defineMessages)({
      header: {
        id: "jutro-floorplan.appFloorPlanDesign.header",
        defaultMessage: "Header"
      },
      search: {
        id: "jutro-floorplan.appFloorPlanDesign.search",
        defaultMessage: "Search"
      },
      navLinks: {
        id: "jutro-floorplan.appFloorPlanDesign.navLinks",
        defaultMessage: "Nav Links"
      },
      aside: {
        id: "jutro-floorplan.appFloorPlanDesign.aside",
        defaultMessage: "Aside"
      },
      footer: {
        id: "jutro-floorplan.appFloorPlanDesign.footer",
        defaultMessage: "Footer"
      }
    });

    var links = [{
      width: 80,
      showNotification: !0
    }, {
      width: 60,
      showNotification: !0
    }, {
      width: 40,
      showNotification: !1
    }, {
      width: 60,
      showNotification: !0
    }, {
      width: 90,
      showNotification: !1
    }, {
      width: 80,
      showNotification: !1
    }, {
      width: 60,
      showNotification: !0
    }, {
      width: 40,
      showNotification: !1
    }],
        AppFloorPlanDesign = function AppFloorPlanDesign(props) {
      var children = props.children,
          _props$showHeader = props.showHeader,
          showHeader = void 0 === _props$showHeader || _props$showHeader,
          _props$showSubHeader = props.showSubHeader,
          showSubHeader = void 0 === _props$showSubHeader || _props$showSubHeader,
          showNavigation = props.showNavigation,
          showDesignGrid = props.showDesignGrid,
          showAside = props.showAside,
          showFooter = props.showFooter,
          scrollContent = props.scrollContent,
          className = props.className,
          theme = Object(external_react_.useContext)(theme_.ThemeContext),
          translator = Object(external_react_.useContext)(locale_.TranslatorContext),
          themeStyles = theme.getStyles("AppFloorPlanDesign", AppFloorPlanDesign_module_default.a),
          subHeader = Object(external_react_.useMemo)(function () {
        return showHeader && showSubHeader && external_react_default.a.createElement(layout_.Flex, {
          gap: "small",
          className: themeStyles.subHeader
        }, times_default()(5, function (key) {
          return external_react_default.a.createElement("div", {
            key: "" + key,
            className: themeStyles.rectangle
          }, external_react_default.a.createElement("div", {
            className: themeStyles.rectangleText
          }));
        }));
      }, [showHeader, showSubHeader, themeStyles]),
          renderHeader = Object(external_react_.useMemo)(function () {
        return showHeader && external_react_default.a.createElement("div", null, external_react_default.a.createElement("div", {
          className: themeStyles.header
        }, external_react_default.a.createElement(layout_.Flex, {
          gap: "small",
          alignItems: "middle"
        }, external_react_default.a.createElement("div", {
          className: themeStyles.square
        }), external_react_default.a.createElement("span", null, translator(AppFloorPlanDesign_messages.header))), external_react_default.a.createElement(layout_.Flex, {
          gap: "small",
          justifyContent: "center"
        }, external_react_default.a.createElement(layout_.Flex, {
          className: themeStyles.search,
          alignItems: "center"
        }, translator(AppFloorPlanDesign_messages.search))), external_react_default.a.createElement(layout_.Flex, {
          gap: "small",
          justifyContent: "right"
        }, times_default()(3, function (key) {
          return external_react_default.a.createElement("div", {
            key: "" + key,
            className: themeStyles.circle
          });
        }))), subHeader);
      }, [themeStyles, subHeader, showHeader]),
          navigation = showNavigation && external_react_default.a.createElement("div", {
        className: themeStyles.navLinks
      }, external_react_default.a.createElement("div", {
        className: themeStyles.navLinksHeader
      }, translator(AppFloorPlanDesign_messages.navLinks)), external_react_default.a.createElement(components_.MenuSkeleton, {
        links: links
      })),
          content = showDesignGrid ? external_react_default.a.createElement(components_.DesignGrid, {
        columns: ["1fr"],
        repeat: "12",
        xcolumns: ["2fr", "1fr"],
        gap: "xlarge"
      }, children) : children,
          aside = showAside && external_react_default.a.createElement("div", {
        className: themeStyles.aside
      }, translator(AppFloorPlanDesign_messages.aside)),
          footer = showFooter && external_react_default.a.createElement("div", {
        className: themeStyles.footer
      }, translator(AppFloorPlanDesign_messages.footer));
      return external_react_default.a.createElement(AppFloorPlanLayout, {
        nav: navigation,
        header: renderHeader,
        aside: aside,
        footer: footer,
        scrollContent: scrollContent,
        className: className
      }, content);
    };

    var AppFloorPlanDesign_AppFloorPlanDesign = AppFloorPlanDesign;
    AppFloorPlanDesign.__docgenInfo = {
      componentName: "AppFloorPlanDesign",
      packageName: "@jutro/floorplan",
      description: "",
      displayName: "AppFloorPlanDesign",
      methods: [],
      actualName: "AppFloorPlanDesign"
    };
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find": function babelRuntimeCorejs3CoreJsStableInstanceFind(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babelRuntimeCorejs3CoreJsStableInstanceMap(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/object/entries": function babelRuntimeCorejs3CoreJsStableObjectEntries(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/entries");
  },
  "@babel/runtime-corejs3/helpers/extends": function babelRuntimeCorejs3HelpersExtends(module, exports) {
    module.exports = require("@babel/runtime-corejs3/helpers/extends");
  },
  "@jutro/components": function jutroComponents(module, exports) {
    module.exports = require("@jutro/components");
  },
  "@jutro/layout": function jutroLayout(module, exports) {
    module.exports = require("@jutro/layout");
  },
  "@jutro/locale": function jutroLocale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/prop-types": function jutroPropTypes(module, exports) {
    module.exports = require("@jutro/prop-types");
  },
  "@jutro/router": function jutroRouter(module, exports) {
    module.exports = require("@jutro/router");
  },
  "@jutro/theme": function jutroTheme(module, exports) {
    module.exports = require("@jutro/theme");
  },
  "@jutro/uiconfig": function jutroUiconfig(module, exports) {
    module.exports = require("@jutro/uiconfig");
  },
  classnames: function classnames(module, exports) {
    module.exports = require("classnames");
  },
  "core-js-pure/features/array/from": function coreJsPureFeaturesArrayFrom(module, exports) {
    module.exports = require("core-js-pure/features/array/from");
  },
  "core-js-pure/features/array/is-array": function coreJsPureFeaturesArrayIsArray(module, exports) {
    module.exports = require("core-js-pure/features/array/is-array");
  },
  "core-js-pure/features/get-iterator": function coreJsPureFeaturesGetIterator(module, exports) {
    module.exports = require("core-js-pure/features/get-iterator");
  },
  "core-js-pure/features/instance/slice": function coreJsPureFeaturesInstanceSlice(module, exports) {
    module.exports = require("core-js-pure/features/instance/slice");
  },
  "core-js-pure/features/is-iterable": function coreJsPureFeaturesIsIterable(module, exports) {
    module.exports = require("core-js-pure/features/is-iterable");
  },
  "core-js-pure/features/symbol": function coreJsPureFeaturesSymbol(module, exports) {
    module.exports = require("core-js-pure/features/symbol");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJsModulesWebDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  "lodash/times": function lodashTimes(module, exports) {
    module.exports = require("lodash/times");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-router-dom": function reactRouterDom(module, exports) {
    module.exports = require("react-router-dom");
  }
});